import { computed } from 'mobx';
import LoadingState from './abstract/LoadingState';
import DateState from './DateState';
import { createObservableInstance } from './helpers';

import AuthState from './AuthState';
import UIState from './UIState';
import UserDataState from './UserDataState';
import UserLocationState from './UserLocationState';
import DataActions from './DataActions';
import EmailVerificationState from './EmailVerificationState';

class RootState extends LoadingState {
  constructor(root) {
    super(root);

    this.authState = createObservableInstance(AuthState, this);
    this.uiState = createObservableInstance(UIState, this);

    this.emailVerificationState = createObservableInstance(
      EmailVerificationState,
      this
    );

    this.userLocationState = createObservableInstance(UserLocationState, this);

    this.dateState = createObservableInstance(DateState, this);

    this.userDataState = createObservableInstance(UserDataState, this);

    this.dataActions = new DataActions(this);
  }

  // Start to show something only when initialized/ready
  get isReady() {
    return this.userDataState.isInitialized;
  }

  get isLoggedIn() {
    return (
      this.userDataState.userImpl &&
      this.userDataState.publicAccount.isInitialized &&
      this.userDataState.profile.isInitialized
    );
  }

  get isAuthorized() {
    return this.isLoggedIn && this.emailVerificationState.isVerified;
  }

  get error() {
    return this.userDataState.error;
  }
}

RootState.annotations = {
  ...LoadingState.annotations,
  isAuthorized: computed,
  isLoggedIn: computed,
  error: computed,
};

export default createObservableInstance(RootState);
export * from './context';
